import { Box, Flex } from '@chakra-ui/react';
import { Button, Icon } from '@mesh.ai/rabbit';

import {
  ExtremelyHelpful,
  ExtremelyUnhelpful,
  Helpful,
  SomewhatHelpful,
  SomewhatUnhelpful,
} from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const INPUT_TYPES = {
  EMOJI: 'EMOJI',
  DROPDOWN: 'DROP_DOWN',
  NUMBER_RATING: 'NUMBER_RATING',
};

const EMOJI_ICONS = (score) => {
  switch (score) {
    case 5:
      return ExtremelyHelpful;
    case 4:
      return SomewhatHelpful;
    case 3:
      return Helpful;
    case 2:
      return SomewhatUnhelpful;
    case 1:
      return ExtremelyUnhelpful;
    default:
      return null;
  }
};

const InteractiveInput = ({
  data,
  onSelect = () => {},
  type = INPUT_TYPES.DROPDOWN,
  selectedId = null,
  descriptionKey = 'description',
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: Array<any>;
  onSelect: (id: string) => void;
  type: string;
  selectedId: string;
  descriptionKey?: string;
}) => {
  const handleClick = (item) => {
    if (item?.id === selectedId) {
      onSelect(null);
    } else {
      onSelect(item.id);
    }
  };

  const noOfItems = data?.length;

  return (
    <Flex
      style={{
        alignItems: 'stretch',
        justifyContent: 'center',
        flexWrap: 'wrap',
        marginTop: isMobileView() ? '0.5rem' : '1rem',
        marginBottom: isMobileView() ? '0.5rem' : '1rem',
        // eslint-disable-next-line no-nested-ternary
        width: isMobileView() ? (noOfItems > 5 && noOfItems <= 7 ? '70%' : '100%') : '100%',
        margin: isMobileView() ? '0 auto' : '0',
      }}
      className="interactive-input-engagement"
    >
      {data.map((item, index) => (
        <Box
          display="flex"
          key={item.id}
          cursor="pointer"
          style={{
            flex: '1 1 0',
            minWidth: isMobileView() ? '55px' : '60px',
            textAlign: 'center',
            minHeight: isMobileView() ? '50px' : '80px',
            maxWidth: isMobileView() ? '70px' : '200px',
            border:
              type === INPUT_TYPES.DROPDOWN ? (isMobileView() ? '1px solid #1565bc' : '1px solid #0D819F') : 'none',
            borderTopLeftRadius: index === 0 ? '8px' : '0',
            borderBottomLeftRadius: index === 0 ? '8px' : '0',
            borderTopRightRadius: index === noOfItems - 1 ? '8px' : '0',
            borderBottomRightRadius: index === noOfItems - 1 ? '8px' : '0',
          }}
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          onClick={() => handleClick(item)}
          bgColor={
            type === INPUT_TYPES.DROPDOWN && selectedId === item.id ? (isMobileView() ? '#1565bc' : '#0D819F') : null
          }
        >
          <Flex
            style={{
              justifyContent: 'center',
              alignItems: 'center',
              flex: '0 0 auto',
            }}
          >
            {type === INPUT_TYPES.EMOJI && (
              <Icon
                IconSVG={EMOJI_ICONS(item.score)}
                style={{
                  color: selectedId === item.id ? (isMobileView() ? '#1565bc' : '#0D819F') : '#666666',
                  width: isMobileView() ? '50px' : '96px',
                  height: isMobileView() ? '50px' : '96px',
                }}
              />
            )}
            {type === INPUT_TYPES.NUMBER_RATING && (
              <Button
                variant={selectedId === item.id ? 'filled' : 'outline'}
                style={{
                  borderRadius: '50%',
                  width: isMobileView() ? '45px' : '60px',
                  height: isMobileView() ? '45px' : '60px',
                  borderColor: selectedId === item.id ? 'initial' : '#E7E7E7',
                  borderWidth: '2px',
                }}
              >
                <TextBodyMedium color={selectedId === item.id ? 'white' : '#333333'}>{item.score}</TextBodyMedium>
              </Button>
            )}
          </Flex>

          <Flex
            style={{
              flexGrow: 1,
              padding: isMobileView() ? '0 0.25rem' : '0 0.5rem',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: isMobileView() ? '0px' : type === INPUT_TYPES.NUMBER_RATING && '8px',
            }}
          >
            <TextLabel
              color={
                // eslint-disable-next-line no-nested-ternary
                selectedId === item.id
                  ? type === INPUT_TYPES.DROPDOWN
                    ? 'white'
                    : isMobileView()
                      ? '#1565bc'
                      : '#0D819F'
                  : '#333333'
              }
            >
              {item[descriptionKey]}
            </TextLabel>
          </Flex>
        </Box>
      ))}
    </Flex>
  );
};

export { InteractiveInput };
